import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=083ebbfa&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083ebbfa')) {
      api.createRecord('083ebbfa', component.options)
    } else {
      api.reload('083ebbfa', component.options)
    }
    module.hot.accept("./FormModal.vue?vue&type=template&id=083ebbfa&", function () {
      api.rerender('083ebbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/FormModal.vue"
export default component.exports